/**
 * _load_script.js — load a vendor script once per document, for a controller.
 *
 * A page-scoped vendor script (Chart.js, Mermaid) placed in a template's body
 * loads asynchronously on a Turbo visit, and turbo:load does not wait for it,
 * so a controller that needs its global must load it and wait on the script's
 * own load event. The promise is kept per source for the life of the document:
 * the global survives Turbo's <body> swaps, so the second page that needs it
 * resolves at once. A failed load is forgotten, so the next visit retries.
 *
 * Used by admin_dashboard_controller.js and admin_promo_scans_controller.js
 * (Chart.js) and admin_database_schema_controller.js (Mermaid).
 */

const loads = new Map();

/** Resolve once window[globalName] exists, loading src if it does not yet. */
export function loadScript(src, globalName) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    if (!loads.has(src)) {
        loads.set(src, new Promise(function (resolve, reject) {
            const script = document.createElement('script');
            script.src = src;
            script.onload = function () { resolve(window[globalName]); };
            script.onerror = function () {
                loads.delete(src);
                reject(new Error('Failed to load ' + src));
            };
            document.head.appendChild(script);
        }));
    }
    return loads.get(src);
}
